import { get } from 'lodash/fp';
import axios from './axios';

export default configurationGuids =>
  axios.post('/api/cart/v2/add-configurations', {
    configurationGuids,
  }).then(get('data'));
